// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"ba5d1daa","140":"c6608a44","240":"faf72dc3","362":"1d362abf","374":"9b10c92b","392":"7193a8d7","410":"25e79b1e","440":"f6872828","471":"800058bb","508":"06eedf5e","618":"aaa1ce89","679":"7958b633","693":"766531d9","838":"b03d14d4"}[chunkId] + ".chunk.js";
};